module.exports = __webpack_public_path__ + "img/Rectangle 754(1).371912ee.png";